module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/placeholder.c161393.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/placeholder.jpg
// module id = yobT
// module chunks = 0